export default __webpack_public_path__ + "static/media/Affrescati_dettagli_sovrapposizione_colori_01.2f139304.jpg";